import React, { useCallback, useEffect, useRef } from "react";

export const useStateWithUnmount = <T>(setState: React.Dispatch<React.SetStateAction<T>>) => {
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    return useCallback(
        (value: T | ((data: T) => T)) => {
            // console.log("setState", value);
            if (mounted.current) {
                setState(value);
            }
        },
        [setState]
    );
};
